// Auto-generated normalizer for table: CAR_BOOKING.VehiculoCombustible
export function vehiculoCombustibleNormalize(row) {
  return {
    idCarga: row.idCarga ?? row.IdCarga ?? row['idCarga'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['idReserva'] ?? 0,
    fechaCarga: row.fechaCarga ?? row.FechaCarga ?? row['fechaCarga'] ?? null,
    litros: row.litros ?? row.Litros ?? row['litros'] ?? '',
    importe: row.importe ?? row.Importe ?? row['importe'] ?? '',
    kmOdometro: row.kmOdometro ?? row.KmOdometro ?? row['kmOdometro'] ?? '',
    estacion: row.estacion ?? row.Estacion ?? row['estacion'] ?? '',
    notas: row.notas ?? row.Notas ?? row['notas'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? '',
  };
}